import axios from 'axios';


function consumptionsv2(data, _callback){
	
	switch (data.type) {
		
		case 'GET_CONTENTS':
			
			var CONTENT;
			const params = { content_guid: data.content_guid };
			try {
				
				// GET del CONTEÚDO
				axios.get(`cms/contents/${data.content_guid}`).then(res => {
					//_callback(res.data.data);
					
					CONTENT = res.data.data;
					CONTENT.type = (CONTENT['mime-type'] == null || CONTENT['mime-type'] == '') ? CONTENT['type_guid'] : CONTENT['mime-type'];				
					CONTENT.annotations = [];
					
					axios.get(`cms/contents/${data.content_guid}/annotations`).then(result_annotations => {
						CONTENT.annotations = result_annotations.data.data;
						_callback(CONTENT);
					}).catch(error => {
						console.log(error);
						//_callback(error);
						_callback(CONTENT);
					});
					
				}).catch(error => {
					console.log(error);
					_callback(error);
				});
				
			} catch (error) {
				console.log(error);
				_callback(error);
			}
			
		break;
		case 'GET_METASCRAPER':

			try {
				axios.get(`cms/metascraper?url=`+data.url).then(_result => {
					_callback(_result.data.data);					
				}).catch(error => {
					console.log(error);
					_callback(error);
				});				
			} catch (error) {
				console.log(error);
				_callback(error);
			}	
			
		break;
		case 'INIT_SESION_CONSUMPTION':
		
			try {	
				axios.post('consumptions', data.params ).then(res => {
					_callback(res.data.data);					
				}).catch(error => {
					console.log(error)
					_callback(error);
				});				
			} catch (error) {
				console.log(error);
				_callback(error);
			}			
		break;
		case 'UPDATE_CONSUMPTION':
		
			try {
				// Consulta a servicio para CERRAR la SESIÓN DEL CONSUMO
				axios.post('consumptions/'+ data.params.consumption_guid +'/progress', data.params ).then(res => {
					_callback(res.data.data);					
				}).catch(error => {
					console.log(error)
					_callback(error);
				});	
			} catch (error) {
				console.log(error);
				_callback(error);
			}			
		break;
		case 'CLOSE_SESION_CONSUMPTION':
		
			try {	
				const params = {
					consumption_guid: data.consumption_guid,
					guid: data.session_guid,
					ended_at: Date.now()
				};
			
				// Consulta a servicio para CERRAR la SESIÓN DEL CONSUMO
				axios.put('consumptions/'+data.consumption_guid+'/sessions/'+data.session_guid, params ).then(res => {
					_callback(res);					
				}).catch(error => {
					console.log(error)
					_callback(error);
				});	
			} catch (error) {
				console.log(error);
				_callback(error);
			}			
		break;
		case 'SEND_REPORT_CONTENT':

			try {
				const params = {
					type: data.params.type,
					comment: data.params.comment,
					content_guid: data.params.content_guid
				};

				axios.post('/cms/contents/'+params.content_guid+'/reports', params ).then(res => {
					_callback(res);					
				}).catch(error => {
					console.log(error)
					_callback(error);
				});	
			} catch (error) {
				console.log(error);
				_callback(error);
			}			
		break;
		case 'POST_ANNOTATION':
			try {
				
				const params_post_annotation = {
					guid: data.params.guid,
					annotation: data.params.annotation
				};
				
				axios.post(`cms/contents/${data.params.content_guid}/annotations`, params_post_annotation ).then(result_annotation => {
					_callback(result_annotation);
				}).catch(error => {
					console.log(error);
					_callback(error);
				});
				
			} catch (error) {
				console.log(error);
				_callback(error);
			}
		break;
		case 'PUT_ANNOTATION':
			try {
				
				const params_put_annotation = {
					guid: data.params.guid,
					annotation: data.params.annotation
				};
				
				axios.put(`cms/contents/${data.params.content_guid}/annotations/${data.params.guid}`, params_put_annotation ).then(result_annotation => {
					_callback(result_annotation);
				}).catch(error => {
					console.log(error);
					_callback(error);
				});
				
			} catch (error) {
				console.log(error);
				_callback(error);
			}
		break;
		case 'DELETE_ANNOTATION':
			try {
				
				const params_delete_annotation = { data: {
					guid: [data.params.guid]
				} };
				
				axios.delete(`cms/contents/${data.params.content_guid}/annotations`, params_delete_annotation ).then(result_annotation => {
					_callback(result_annotation);
				}).catch(error => {
					console.log(error);
					_callback(error);
				});
				
			} catch (error) {
				console.log(error);
				_callback(error);
			}
		break;
		
	}
		
}

export default consumptionsv2;